export const DsDialogContentTextOverrides = {};
